<template>
  <div>

    <div v-if="showAddButton" class="supplier-stage-action-buttons">
      <div
          class="d-none d-sm-inline-block btn btn-sm btn-success shadow-sm"
          @click="openAddSupplierModal()"
      >
        <i class="fas fa-plus-circle"/>
        Dodaj
      </div>
      <div
          class="d-none d-sm-inline-block btn btn-sm btn-primary shadow-sm ms-2"
          @click="openImportAssistant()"
      >
        <i class="fas fa-file-upload"/>
        Importuj dostawców
      </div>
    </div>


    <div class="supplier-data-stage">
      <div class="row">
        <SearchBar2
            :searchOptions="fieldsAvailableForSearch"
            @searchRequest="searchOnList($event)"
        />
      </div>

      <div class="supplier-data-table-container">
        <div>
          <CommonTable2
              :table="tableData"
              rowIdentifier="guid"
              @onItemAction="runAction($event)"
              @onSort="sort($event)"
              @onMassAction="runMassAction($event)"
              @onCheckItem="checkAction($event)"
              @onSelectRow="selectRow($event)"
              :key="refreshTable"
              :currentPage="currentPage"
              :totalRows="commonModule.getSuppliersDataTotal"
              :totalPages="commonModule.getSuppliersDataPagesCount"
              :showPaginationTop="true"
              :showPaginationBottom="true"
              :multiselect="multiselect"
              @onPageChange="currentPage = $event"
              :sortColumn="sortingKey"
              :sortDirection="sortingDirection"
              :showMassActions="showMassActions"
              :showRowActions="showRowActions"
              :initiallyCheckedItemsData="selectedSuppliersData"
              :showCheckboxColumn="showCheckboxColumn"
              :enableRowSelection="enableRowSelection"
              :initiallyVisibleColumns="visibleColumnsFilter"
              :stickyScrollbarBottom="0"
              :exportEnabled="true"
              @onExportTableData="exportSuppliers"
          />
        </div>
        <slot name="bottom"></slot>
      </div>
    </div>

    <b-modal
        v-model="showSupplierDataModal"
        id="supplier-data-form-modal"
        scrollable
        :title="supplierDataModalTitle"
        title-class="font-18"
        hide-footer
        size="lg"
        style="z-index:100020!important;"
        @hide="closeSupplierDataModal()"
    >
      <div v-if="showSupplierDataModal" style="margin-top: 20px!important;">
        <CommonForm
            id="supplier-data-form"
            :structure="supplierDataFormStructure"
            :data="currentSupplierDataFormData"
            :key="currentSupplierDataFormData"
            @onSubmit="saveSupplierData($event)"
            @onCancel="cancelSupplierDataEdit"
            submitButtonText="Zapisz"
            :submitButtonEnabled="true"
            cancelButtonText="Anuluj"
            :cancelButtonEnabled="true"
        >
          <template v-if="currentSupplierDataFormData.guid != null" v-slot:bindLocalSuppliersActions>
            <div class="row">
              <div class="col-6" style="text-align: center;">
                <div class="btn btn-info" @click="showBoundLocalSuppliersModal = true"><i class="fa fa-search-minus"/>Pokaż
                  powiązanych lokalnych dostawców
                </div>
              </div>
              <div class="col-6" style="text-align: center;">
                <div class="btn btn-success" @click="showBindingModeLocalSuppliersModal = true"><i class="fa fa-link"/>Powiąż
                  lokalnych dostawców
                </div>
              </div>


            </div>
          </template>


        </CommonForm>
      </div>


    </b-modal>
    <b-modal
        v-model="showSupplierImportAssistant"
        title="Import dostawców"
        scrollable
        hide-footer
        style="z-index:100011!important;"
        size="xl"
    >
      <SuppliersImportAssistant
          v-if="showSupplierImportAssistant"
          title="Asystent importu dostawców"
          @onImportSuccess="onImportSuccess"
      />
    </b-modal>

    <b-modal
        v-model="showBoundLocalSuppliersModal"
        id="central-supplier-binding-form-modal"
        scrollable
        title="Lista lokalnych dostawców powiązanych z dostawcą centralnym"
        title-class="font-18"
        size="xl"
        style="z-index:100030!important;"
        :okDisabled="true"
        :cancelDisabled="true"
        :hideFooter="true"

    >
      <div class="form-group">
        <label>Dostawca centralny:
          {{ currentSupplierDataFormData.name }}</label>
        <div v-if="showBoundLocalSuppliersModal">


          <BoundLocalSuppliersList
              :boundWithCentralGuid="currentSupplierDataFormData.guid"
              @onSelect="selectLocalSupplier"
              @onUnbind="refreshBoundSuppliersList"
              @onBind="refreshBoundSuppliersList"
              :bindModeOn="false"

          />
        </div>
      </div>


    </b-modal>

    <b-modal
        v-model="showBindingModeLocalSuppliersModal"
        id="central-supplier-binding-form-modal"
        scrollable
        title="Powiąż wybranych dostawców lokalnych z dostawcą centralnym"
        title-class="font-18"
        size="xl"
        style="z-index:100030!important;"
        :okDisabled="true"
        :cancelDisabled="true"
        :hideFooter="true"

    >
      <div class="form-group">
        <label>Wybrany dostawca centralny:
          {{ currentSupplierDataFormData.name }}</label>
        <div v-if="showBindingModeLocalSuppliersModal">


          <BoundLocalSuppliersList
              :boundWithCentralGuid="currentSupplierDataFormData.guid"
              @onSelect="selectLocalSupplier"
              @onUnbind="refreshBoundSuppliersList"
              @onBind="refreshBoundSuppliersList"
              :bindModeOn="true"

          />
        </div>
      </div>


    </b-modal>


  </div>
</template>

<script>
import SearchBar2 from "@/components/widgets/SearchBar2.vue";
import {log} from "@/state/pinia/log";
import CommonForm from "@/components/widgets/CommonForm.vue";
import {supplierFormFields} from "./data/supplierFormFields";
import {apiRequestsHelper} from "@/state/pinia/apiRequestHelper";
import {commonAppHelperMethods} from "./helper/commonAppHelperMethods";
import CommonTable2 from "@/components/widgets/CommonTable2.vue";
import Swal from "sweetalert2";
import BoundLocalSuppliersList from "./BoundLocalSuppliersList.vue";
import {BModal} from "bootstrap-vue-next";
import {useSimplepharmAuthModule} from "@/state/pinia/simplepharmAuthModule";
import {mapStores} from "pinia";
import {useCommonAppModule} from "@/state/pinia/commonAppModule";
import {useLazyLoaderModule} from "@/state/pinia/lazyloaderManagerModule";
import SuppliersImportAssistant from "@/views/DrugstoreCommonManager/SuppliersImportAssistant.vue";
import {useCommonExportModule} from "@/state/pinia/commonExportModule";




export default {
  name: "SupplierDataList",
  props: {
    multiselect: {
      type: Boolean,
      default: true,
    },
    showMassActions: {
      type: Boolean,
      default: () => true
    },
    showRowActions: {
      type: Boolean,
      default: () => true
    },
    showAddButton: {
      type: Boolean,
      default: () => true
    },
    selectedSuppliersData: {
      type: Array,
      default: () => []
    },
    showCheckboxColumn: {
      type: Boolean,
      default: () => true
    },
    enableRowSelection: {
      type: Boolean,
      default: () => true
    },
    visibleColumnsFilter:{ // declare only columns keys You want to see
      type:Array,
      default: ()=>[]
    }
  },
  emits: ["onSelect","onSelectRow"],
  components: {
    SuppliersImportAssistant,
    BoundLocalSuppliersList,
    BModal,
    CommonForm,
    SearchBar2,
    CommonTable2,
  },
  data() {
    return {
      tableData: {},
      currentPage: 1,
      sortingDirection: "ASC",
      sortingKey: "name",
      searchRequest: {
        searchPhrase: null,
        searchKey: null,
      },
      supplierDataRows: [],
      supplierDataModalTitle: "",
      showBoundLocalSuppliersModal: false,
      showBindingModeLocalSuppliersModal: false,
      tableMassActions: [
        {
          text: "Usuń",
          icon: "fas fa-trash",
          action: "delete-supplier-data",
          class: "btn btn-danger table-actions-button edit-button",
          enabled: true,
          tooltip: "Usuń zaznaczonych dostawców",
        },
        {
          text: "Scal dostawców",
          icon: "fas fa-link",
          action: "merge-suppliers",
          class: "btn btn-success table-actions-button edit-button",
          enabled: true,
          tooltip: "Scal dostawców centralnych w jednego",
        }
      ],
      fieldsAvailableForSearch: [
        {
          name: "Nazwa dostawcy",
          key: "name",
        },
        {
          name: "Kamsoft ID dostawcy",
          key: "centralId",
        },
        {
          name: "NIP dostawcy",
          key: "nip",
        },

      ],
      availableHeaders: [
        {
          text: "ID",
          key: "id",
          type: "number",
          sortable: true,
        },
        {
          text: "CKT",
          key: "centralCartReference",
          type: "number",
          sortable: true,
        },
        {
          text: "Kamsoft ID",
          key: "centralId",
          type: "number",
          sortable: true,
        },
        {
          text: "NIP",
          key: "nip",
          type: "number",
          sortable: true,
        },
        {
          text: "Nazwa dostawcy",
          key: "name",
          type: "text",
          sortable: true,
        },
        {
          text: "Utworzono",
          key: "createdAt",
          type: "text",
          sortable: true
        },
        {
          text: "Akcje",
          key: "actions",
          type: "actions",
          actions: [
            {
              text: "",
              icon: "fas fa-edit",
              action: "edit-supplier-data",
              enabled: true,
              tooltip: "Edytuj dostawcę",
              class: "btn btn-info btn-sm table-actions-button edit-button",
            },
            {
              text: "",
              icon: "fas fa-trash",
              action: "delete-supplier-data",
              enabled: true,
              tooltip: "Usuń dostawcę",
              class: "btn btn-danger btn-sm table-actions-button edit-button",
            }


          ],
        },
      ],
      refreshTable: true,
      showSupplierDataModal: false,
      supplierDataFormStructure: supplierFormFields.supplierDataForm,
      currentSupplierDataFormData: {},
      emptySupplierDataFormData: {
        guid: null,
        name: null,
        address: null,
        city: null,
        zipcode: null,
        bankAccount: null,
        bankName: null,
        nip: null,
        regon: null,
        phone: null,
        email: null,
        concession: null,
        centralId: null,
        isOwnSupplier: false,
        createdAt: null,
      },
      showSupplierImportAssistant: false,
    };
  },
  computed: {
        simplepharmAuth(){
      return useSimplepharmAuthModule();
    },
    commonModule(){
      return useCommonAppModule();
    },
    lazyloaderModule(){
      return useLazyLoaderModule();
    },
    commonExportModule() {
      return useCommonExportModule();
    },
  },
  methods: {
    exportSuppliers(event) {
      const payload = {
        exportType: "stock-suppliers",
        outputFileFormat: "XLSX",
        defaultFileNamePrefix: "dostawcy_",
        columns:event.visibleHeaders,
        params: {
          selectedItems: event.selectedItems
        }
      }
      this.commonExportModule.httpExportGenericTable(payload);

    },
    openImportAssistant() {
      this.showSupplierImportAssistant = true;
    },
    onImportSuccess(successStr) {
      // close modal and refresh on success
      if (successStr === 'true') {
        this.showSupplierImportAssistant = false;
        this.refreshSupplierData();
      }
    },
    searchOnList(searchRequest) {
      this.searchRequest = searchRequest;
      this.refreshSupplierData();
    },
    runAction(event) {
      if (event.action.action === "edit-supplier-data") {
        log.log(event);
        var payload = {
          guid: event.itemData.guid,
        };

        this.commonModule.httpGetSupplierByGuid(payload).then((response) => {
          log.log(response);
          if (response) {
            this.currentSupplierDataFormData = JSON.parse(JSON.stringify(response.data.payload));
            this.supplierDataModalTitle = "Edytuj dostawcę centralnego";
            this.showSupplierDataModal = true;
          } else  {
            this.showSupplierDataModal = false;
          }
          this.lazyloaderModule.setDisplayLazyLoader(false)
        })
      } else if (event.action.action === "delete-supplier-data") {
        this.deleteSuppliersByGuids([event.itemData.guid]);
      }
    },

    openAddSupplierModal() {
      this.currentSupplierDataFormData = JSON.parse(JSON.stringify(this.emptySupplierDataFormData));
      this.supplierDataModalTitle = "Dodaj dostawcę centralnego";
      this.showSupplierDataModal = true;


    },

    runMassAction(event) {
      log.log(event);
      if (event.action.action === "delete-supplier-data") {
        this.deleteSuppliersByGuids(event.items)
      } else if (event.action.action === "merge-suppliers") {
        this.mergeSuppliersAndRemove(event.items).then(()=>{
          this.refreshSupplierData();
        });
      }
    },
    deleteSuppliersByGuids(guids, isMerge = false) {
      var dialogTitle = "Usunąć dostawców?";
      var dialogText = "Czy na pewno usunąć zaznaczonych dostawców?. Operacja jest nieodwracalna!";
      var dialogIcon = "warning";
      if(isMerge){
        dialogTitle = "Czy usunać źródłowych dostawców?";
        dialogText = "Czy usunać źródłowych dostawców i pozostawić tylko dostawcę docelowego?. Dostawcy źródłowi nie mają już dowiązanych żadnych lokalnych dostawców.";
        dialogIcon = "success";
      }

      // ask user if is sure to do that:
      Swal.fire({
        title: dialogTitle,
        text: dialogText,
        icon: dialogIcon,
        showCancelButton: true,
        confirmButtonColor: "#34c38f",
        cancelButtonColor: "#f46a6a",
        cancelButtonText: "Nie",
        confirmButtonText: "Tak",
        customClass: {
          container: "swal-highest"
        },
        dangerMode: true,
      }).then((result) => {
        if (result.value) {
          var payload = {
            guids: guids,
          };

          this.commonModule.httpDeleteSuppliersByGuids(payload).then(() => {
            this.refreshSupplierData();
          });
        } else {
          // Do nothing...
        }
      });


    },

    mergeSuppliersAndRemove(guidsSelected){
      return this.mergeSuppliers(guidsSelected).then((response)=>{
        if(response.isConfirmed === true){
          const targetSupplierGuid = response.targetSupplierGuid;
          // remove target supplier guids from selected guids that are about to be deleted:
          const guidsSelectedWithoutTarget = guidsSelected.filter(item=>item !== targetSupplierGuid);

          return this.deleteSuppliersByGuids(guidsSelectedWithoutTarget,true);
        }
      });
    },

    mergeSuppliers(guidsSelected) {
      var selectedSuppliers = [];

      for (var i = 0; i < guidsSelected.length; i++) {
        this.supplierDataRows.find((item) => {
          if (item.guid === guidsSelected[i]) {
            var supplierToSelect = "[ID: " + item.id + "] " + item.name;
            selectedSuppliers.push(supplierToSelect);
          }
        });
      }

      // open Swal dialog with selectbox containing selected suppliers:
      var targetCentralSupplier = null;
      return Swal.fire({
        title: "Wybierz dostawcę docelowego, a nastepnie kliknij 'Scal' aby połączyć dostawców",
        html: '<select id="swal-select" class="swal2-select" style=" margin-left: unset!important;margin-right: unset!important;">' +
            '<option value="">Wybierz dostawcę docelowego</option>' +
            selectedSuppliers.map((item) => {
              return '<option value="' + item + '">' + item + '</option>';
            }).join('') +
            '</select>',
        showCancelButton: true,
        confirmButtonText: "Scal",
        cancelButtonText: "Anuluj",
        customClass: {
          container: "swal-highest"
        },
        preConfirm: () => {
          var selectedCentralSupplierToBind = document.getElementById("swal-select").value;
          // parse selectedCentralSupplierToBind to ID:
          const id = this.extractID(selectedCentralSupplierToBind.toString());
          this.supplierDataRows.find((item) => {
            if (item.id === parseInt(id)) {
              targetCentralSupplier = item;
            }
          });

        }
      }).then((result) => {
        if(result.isConfirmed){

          if (targetCentralSupplier == null) {
            Swal.fire({
              title: "Brak docelowego centralnego dostawcy",
              text: "Nie wybrano centralnego dostawcy do powiązania.",
              icon: "info",
              confirmButtonText: "OK",
              customClass: {
                container: "swal-highest"
              },
            });
            return new Promise((resolve) => {
              resolve({isConfirmed: false});
            });
          } else {
            this.lazyloaderModule.setDisplayLazyLoader(true);
            this.lazyloaderModule.setProgressBarMessage("Scalanie centralnych kartotek...");
            var payload = {
              targetCentralSupplierGuid: targetCentralSupplier.guid,
              sourceCentralSuppliersGuids: guidsSelected
            }

            return this.commonModule.httpMergeCentralSuppliers(payload)
                .then((response) => {
                  if(response.status === 200) {
                    return new Promise((resolve) => {
                      resolve({
                        isConfirmed: true,
                        targetSupplierGuid: targetCentralSupplier.guid

                      });
                    });
                  }
                  return apiRequestsHelper.handleResponseWithDialogs(response, false);
                }).catch((error) => {
                  return apiRequestsHelper.catchResponseError(error, "httpMergeCentralSuppliers");
                });




          }
        }else{
          return new Promise((resolve) => {
            resolve({isConfirmed: false});
          });
        }

      });
    },

    extractID(str) {
      const match = str.match(/\[ID: (\d+)\]/);
      return match ? match[1] : null;
    },


    sort(sortKey) {
      log.log(sortKey);
      this.sortingKey = sortKey;
      this.refreshSupplierData();
      this.toggleSortingDirection();
    },
    toggleSortingDirection() {
      if (this.sortingDirection === "ASC") {
        this.sortingDirection = "DESC";
      } else {
        this.sortingDirection = "ASC";
      }
    },
    checkAction(event) {
      log.log(event.itemsData);
      this.$emit("onSelect", event.itemsData);
    },
    selectRow(event) {
      log.log(event);
      this.$emit("onSelectRow", event);
    },
    refreshSupplierData() {
      this.lazyloaderModule.setDisplayLazyLoader(true);
      this.lazyloaderModule.setProgressBarMessage("Pobieranie danych o dostawcach.");
      this.refreshSupplierDataList();
    },
    refreshSupplierDataList() {
      this.lazyloaderModule.setDisplayLazyLoader(true);
      this.lazyloaderModule.setProgressBarMessage("Pobieranie listy dostawców.");
      this.commonModule.setSuppliersData([]);

      this.searchAndFilterRequest = {
        fields: null,
        search: this.searchRequest,
        filters: null,
      };

      var payload = {
        searchAndFilterRequest: this.searchAndFilterRequest,
        currentPage: this.currentPage,
        sortingDirection: this.sortingDirection,
        sortingKey: this.sortingKey,
      };
      this.refreshTable = false;
      this.commonModule.httpGetSuppliersPaging(payload).then(() => {
        this.supplierDataRows = [];
        var supplierData = JSON.parse(JSON.stringify(this.commonModule.getSuppliersData));
        for (var i = 0; i < supplierData.length; i++) {
          supplierData[i]["createdAt"] = commonAppHelperMethods.formatDatetimeToLocaleFormat(supplierData[i]["createdAt"]);
          this.supplierDataRows.push(supplierData[i]);
        }

        var suppliersHeaders = []
        for (var j = 0; j < this.availableHeaders.length; j++) {
          if (this.availableHeaders[j].key === "nip") {

            this.availableHeaders[j].class = "sticky-header col-mid-text";
            suppliersHeaders.push(this.availableHeaders[j]);
          } else if (this.availableHeaders[j].key === "nazwa_kartoteki_centralnej_dostawcy") {
            this.availableHeaders[j].sortable = false;
            suppliersHeaders.push(this.availableHeaders[j]);
          } else {
            suppliersHeaders.push(this.availableHeaders[j]);
          }
        }


        this.tableData["headers"] = suppliersHeaders;
        this.tableData["massActions"] = this.tableMassActions;
        this.tableData["data"] = this.supplierDataRows;
        this.refreshTable = true;
      });
    },
    saveSupplierData(event) {
      this.lazyloaderModule.setDisplayLazyLoader(true);
      this.lazyloaderModule.setProgressBarMessage("Zapisywanie zmian w dostawcy");

      var currentSelectedSupplierGuid = this.currentSupplierDataFormData.guid;
      if (currentSelectedSupplierGuid == null) {
        var createPayload = {
          supplierData: event
        }
        this.commonModule.httpAddSupplier(createPayload).then(() => {
          this.currentSupplierDataFormData = JSON.parse(JSON.stringify(this.emptySupplierDataFormData));
          this.showSupplierDataModal = false;
          this.refreshSupplierData();
        });

      } else {
        var updatePayload = {
          supplierData: event,
          guid: this.currentSupplierDataFormData.guid,
        };
        this.commonModule.httpUpdateSupplierData(updatePayload).then(() => {
          this.currentSupplierDataFormData = JSON.parse(JSON.stringify(this.emptySupplierDataFormData));
          this.showSupplierDataModal = false;
          this.refreshSupplierData();
        });
      }


    },
    closeSupplierDataModal() {
      log.log("closing supplier data modal");
      this.showSupplierDataModal = false;
    },
    cancelSupplierDataEdit() {
      this.showSupplierDataModal = false;
    },
    selectLocalSupplier(selectedSupplier) {
      // no need to do anything here
      log.log(selectedSupplier);
    },
    refreshBoundSuppliersList() {
      log.log("refreshing bound suppliers list");

    },

  },
  watch: {
    currentPage: {
      handler() {
        this.refreshSupplierData();
      },
      deep: true,
    },
  },
  created() {
    this.refreshSupplierData();
  },
};
</script>

<style scoped>
.supplier-data-stage {
  margin-left: 16px;
  margin-right: 16px;
}

.supplier-data-table-container {
}

.table-success {
  background-color: #d4edda;
  color: #155724;
}

.table-info {
  background-color: #d4edda;
  color: #152c57;
}

.table-warning {
  background-color: #fff3cd;
  color: #856404;
}

.table-danger {
  background-color: #f8d7da;
  color: #721c24;
}

.supplier-stage-action-buttons {
  text-align: right;
  margin-right: 4px;
  margin-bottom: 16px;
  margin-top: 16px;
}

.swal2-select {
  width: 100%;
  margin-left: unset !important;
  margin-right: unset !important;
  margin-top: 10px;
  margin-bottom: 10px;
}
</style>
